<template>
    <b-button
        v-if="!hidden"
        @click="() => { modalState = true }"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        v-show="!userPreferenceStore.coi.lightMode"
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner type="grow" label="Loading..." small />
        </span>
        <span v-else>Tracking entfernen</span>
        <b-modal
            v-model="modalState"
            id="modal-unfreeze-order"
            title="Tracking Entfernen"
            @ok="submit()"
            cancel-title="abbrechen"
            size="md"
        ><!-- modal -->
            <span>Wollen Sie wirklich das Tracking entfernen?</span>
        </b-modal>
    </b-button>
</template>
<script>
    import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

    export default {
        setup(){
            const userPreferenceStore = useUserPreferenceStore();
            return {userPreferenceStore}
        },        
        props: [ 'customerOrder', 'authorization', 'orderStates' ]
        , data() {
            return {
                modalState: false,
                httpRequestInProgress: false
            }
        }
        , computed: {
           hidden: function() {
               return this.orderStates.codes.OPEN == this.customerOrder.orderState;
           },
           disabled: function() {
               return this.httpRequestInProgress
                   || (!this.authorization.shipper)
                   || (![this.orderStates.codes.WAIT, this.orderStates.codes.DONE]
                       .includes(this.customerOrder.orderState));
           }
        }
        , methods: {
            submit()
            {
                this.httpRequestInProgress = true;
                const hollow = { customerOrder: { id: this.customerOrder.id } }
                Promise.all([
                    axios.post('/customerorder/action/removetracking', hollow ),
                    new Promise(r => setTimeout(r, 750))
                ]).then( ([response]) => {
                    this.httpRequestInProgress = false;
                    this.customerOrder.customerorderitems[0].customerorderitemdeliveryaddition = null;
                    let clone = _.cloneDeep(this.customerOrder);
                    delete clone.customerorderitems[0].customerorderitemdeliveryaddition;//this should actually remove the addition thing.
                    this.$emit('mutatedCustomerOrder', clone);
                }).catch( error => {
                    alert("konnte Status nicht ändern");
                    console.error(error);
                });
            }
        }
    }
</script>
